export default class SuggestResult {
    public field: string = null;
    public suggestion: string = null;
}